module.exports = __webpack_public_path__ + "img/dview_renjijiemian.6bed3e27.jpg";